<template>
  <div class="register-main-div">
    <div class="register-action-div">
      <div class="register-form-container">
        <h2>Ro'yxatdan o'tish</h2>
        <form class="register-form" @submit.prevent="register">
          <div class="div-sign-in-text">
            <span>Agar hisobingiz bo'lsa</span>
            <a class="create-user-text" href="/login">Kirish</a>
          </div>
          <div class="input-container">
            <input type="text" v-model="firstName" required />
            <label :class="{ active: firstName, filled: firstName }">Ism</label>
          </div>

          <div class="input-container">
            <input type="text" v-model="lastName" required />
            <label :class="{ active: lastName, filled: lastName }"
              >Familiya</label
            >
          </div>

          <div class="input-container">
            <input type="text" v-model="email" required />
            <label :class="{ active: email, filled: email }">Email</label>
          </div>

          <div class="input-container">
            <input type="tel" v-model="phone" required />
            <label :class="{ active: phone, filled: phone }"
              >Telefon raqam</label
            >
          </div>

          <div class="input-container">
            <input
              :type="showPassword ? 'text' : 'password'"
              v-model="password"
              @input="checkPasswords"
              :class="{
                'input-error': passwordError,
                'input-success': !passwordError && password !== '',
              }"
              required
            />
            <label
              :class="{
                active: password,
                filled: password,
              }"
              >Parolni kiriting</label
            >
            <img
              class="eye-icon"
              src="../assets/image/svg-eye.svg"
              alt="Toggle Password"
              @click="togglePassword"
              v-if="!showPassword"
            />
            <img
              class="eye-icon"
              src="../assets/image/svg-eyeopen.svg"
              alt="Toggle Password"
              @click="togglePassword"
              v-if="showPassword"
            />
          </div>

          <div class="input-container">
            <input
              :type="showPassword ? 'text' : 'password'"
              v-model="confirmPassword"
              @input="checkPasswords"
              :class="{
                'input-error': passwordError,
                'input-success': !passwordError && confirmPassword !== '',
              }"
              required
            />
            <label
              :class="{
                active: confirmPassword,
                filled: confirmPassword,
              }"
              >Parolni takrorlang</label
            >
          </div>
          <button type="submit" class="register-button">
            Ro'yxatdan o'tish
          </button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/http";
import { ElMessage } from "element-plus";

export default {
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
      showPassword: false,
      passwordError: false,
    };
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    checkPasswords() {
      this.passwordError = this.password !== this.confirmPassword;
    },
    register: async function () {
      if (this.password !== this.confirmPassword) {
        ElMessage({
          message: "Parollar mos kelmaydi!",
          type: "error",
          showClose: true,
        });
        return;
      }
      const body = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phone: this.phone,
        password: this.password,
      };
      try {
        await http.post("/auth/register", body);
        ElMessage({
          message: "Ro'yxatdan o'tish muvaffaqiyatli!",
          type: "success",
          showClose: true,
        });
        this.$router.push("/login");
      } catch (error) {
        ElMessage({
          message: "Ro'yxatdan o'tishda xato yuz berdi!",
          type: "error",
          showClose: true,
        });
      }
    },
  },
};
</script>

<style scoped>
.create-user-text {
  color: #4880ff;
  text-decoration: underline;
  cursor: pointer;
}
.div-sign-in-text {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.register-main-div {
  background-color: #568aff;
  height: 100vh;
  width: 100vw;
  display: grid;
  place-items: center;
}

.register-action-div {
  background-color: #fff;
  width: 500px;
  height: 650px;
  border-radius: 10px;
}

.register-form-container {
  margin-top: 50px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

h2 {
  text-align: center;
  margin-bottom: 15px;
}

.input-container {
  position: relative;
  margin-bottom: 20px;
}

input {
  width: 100%;
  padding: 13px 13px 13px 13px;
  border-radius: 5px;
  background-color: #fff;
  border: 1px solid #d8d8d8;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s ease;
}

input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.input-error {
  border-color: red;
  box-shadow: 0 0 5px rgba(201, 30, 30, 0.78);
}

.input-success {
  border: 1px solid #d8d8d8;
}

label {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #aaa;
  font-size: 15px;
  transition: all 0.3s ease-in-out;
  pointer-events: none;
}

input:focus + label,
label.active {
  top: 2px;
  font-size: 12px;
  color: #007bff;
  background: white;
  padding: 0 3px;
}

input:valid + label {
  color: #555;
}

.eye-icon {
  position: absolute;
  right: 10px;
  width: 20px;
  height: 40px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.eye-icon:hover {
  opacity: 1;
}

.register-button {
  padding: 13px;
  border-radius: 5px;
  border: none;
  color: #fff;
  font-weight: bold;
  font-size: 18px;
  background: #4880ff;
  cursor: pointer;
}

.register-button:hover {
  background-color: #fff;
  border: 1px solid #4880ff;
  color: #4880ff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

form {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 0 25px;
}
</style>
